import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Loading } from "../../../components/common/Loading";
import ListaContratacion from "../../../components/services/admin/ListaContratacion";
import LayoutService from "../../../components/common/LayoutService";
import NoServices from "../../../components/services/admin/NoService";
import { isEmpty } from "../../../components/common/helpers";
import { getCurrentProfile } from "../../../actions/profile";
import { getCategories } from "../../../actions/categories";

import { useSelector, useDispatch } from "react-redux";

const Servicios = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const services = useSelector(state => state.profile.profile.servicios);
  const paginas = useSelector(state => state.profile.profile.paginas);
  const loading = useSelector(state => state.profile.loading);
  const [servicios, setServicios] = useState([]);

  useEffect(() => {
    dispatch(getCurrentProfile());
    dispatch(getCategories())
  }, []);

  useEffect(() => {
    if (!loading) {
      return setServicios(services);
    }
  }, [services]);

  const irA = where => {
    navigate(where);
  }

  if (loading) {
    return <Loading />
  }

  return (
    <LayoutService>
      {
        (!isEmpty(servicios) || !isEmpty(paginas))
          ? <ListaContratacion
            services={servicios}
            paginas={paginas || []}
            loading={loading}
            irA={irA}
            initialTab={location.state?.tab || 0}
            aviso={location.state?.aviso || ""}
          />
          : <NoServices irA={irA} />
      }
    </LayoutService>
  );
}

export default Servicios;
